<div class="headings">
  <h4 class="content-heading">
    {{ 'pages.userFamily.stepConfirmFamilyMember.heading' | translate }}
  </h4>
</div>

<!-- Loading indicator -->
<mat-spinner *ngIf="loading" diameter="20"></mat-spinner>

<!-- Content when loaded -->
<div *ngIf="!loading" class="confirm-content">
  
  <!-- User cards row -->
  <div class="row">
    <div class="card-with-relationship">
      <!-- Selected profile card -->
      <app-user-family-request-card
        [user]="selectedProfile"
        [link]="selectedProfileFamilyLinkWithSelectedMember?.link"
        [familyApproved]="selectedProfileFamilyLinkWithSelectedMember?.familyApproved"
        [editable]="true"
        (linkChanged)="onSelectedProfileLinkChanged($event)"
      ></app-user-family-request-card>

      <!-- Relationship text for selected profile -->
      <p class="relationship-text" *ngIf="getSelectedProfileRelationshipKey()">
        {{ getSelectedProfileRelationshipKey() | translate: {
          person: getProfileFullName(selectedProfile),
          relative: getProfileFullName(selectedFamilyMemberProfile)
        } }}
      </p>
    </div>

    <div class="card-with-relationship">
      <!-- Family member profile card -->
      <app-user-family-request-card
        [user]="selectedFamilyMemberProfile"
        [link]="selectedFamilyMember.link"
        [familyApproved]="selectedFamilyMember?.familyApproved"
        [editable]="true"
        (linkChanged)="onFamilyMemberLinkChanged($event)"
      ></app-user-family-request-card>

      <!-- Relationship text for family member -->
      <p class="relationship-text" *ngIf="getFamilyMemberRelationshipKey()">
        {{ getFamilyMemberRelationshipKey() | translate: {
          person: getProfileFullName(selectedFamilyMemberProfile),
          relative: getProfileFullName(selectedProfile)
        } }}
      </p>
    </div>
  </div>

  <!-- Uploaded documents section -->
  <div class="row" *ngIf="selectedFamilyMember?.proofOfIdentity?.length > 0">
    <div class="files-wrapper">
      <div class="files-header-row">
        <h4 class="files-header">{{ 'pages.userFamily.uploaded.label' | translate }}</h4>
        <button *ngIf="approvalGuidelines" mat-icon-button class="approval-guide-btn" (click)="showApprovalGuide = !showApprovalGuide">
          <span class="icon-info"></span>
        </button>
        <div *ngIf="showApprovalGuide && approvalGuidelines" class="approval-guide-popover">
          <div class="approval-guide-header">
            <span>{{ 'pages.userFamily.approvalGuide' | translate }}</span>
            <button class="approval-guide-close" (click)="showApprovalGuide = false"><span class="icon-close"></span></button>
          </div>
          <div class="approval-guide-content ql-content-wrapper" [innerHTML]="approvalGuidelines"></div>
        </div>
      </div>
      <div class="files-container">
        <div 
          *ngFor="let url of selectedFamilyMember.proofOfIdentity; let i = index"
          class="file"
          (click)="viewDocument(url)"
          [ngStyle]="urlIsImage(url) ? {'background-image': 'url(' + url +')'} : ''">
          <span *ngIf="!urlIsImage(url)" class="pdf-file-icon icon-office-file-pdf"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- Conflicts section -->
  <div class="row" *ngIf="selectedFamilyMember.conflicts?.length > 0">
    <div class="conflicts">
      <hr/>
      <div class="conflict-item" *ngFor="let conflict of selectedFamilyMember.conflicts">
        <span class="conflict-icon icon-close-circle"></span>{{conflict}}
      </div>
    </div>
  </div>
</div>